import { onBeforeUnmount, onMounted } from 'vue';

export default function onEscapePressed(cb) {
  let escapeHandler = (event) => {
    if (event.key === 'Escape') {
      cb(event);
    }
  }

  onMounted(() => {
    document.body.addEventListener('keydown', escapeHandler, false);
  });

  onBeforeUnmount(() => {
    document.body.removeEventListener('keydown', escapeHandler)
  });
}
